import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
      <g>
        <g>
          <path
            fill="#111111"
            d="M387.439,170.067h-9.824c-15.123,0-27.496-12.373-27.496-27.496V60.687
			c0-15.123,12.373-27.496,27.496-27.496h9.824c15.123,0,27.496,12.373,27.496,27.496v81.883
			C414.936,157.694,402.562,170.067,387.439,170.067z"
          />
        </g>
        <g>
          <path
            fill="#111111"
            d="M133.786,170.067h-10.424c-15.244,0-27.716-12.472-27.716-27.716V60.907
			c0-15.244,12.472-27.716,27.716-27.716h10.424c15.244,0,27.716,12.472,27.716,27.716v81.444
			C161.502,157.595,149.03,170.067,133.786,170.067z"
          />
        </g>
        <path
          fill="none"
          stroke="#111111"
          stroke-width="20"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="
		M351.532,118.951l0.036,25.573c-0.095,13.402,10.835,24.333,24.237,24.333h15.208c13.402,0,24.333-10.931,24.333-24.333V59.83
		c0-13.402-10.931-24.333-24.333-24.333h-15.208c-13.402,0-24.333,10.931-24.333,24.333l0.036,24.808h-190.7l0.036-24.808
		c0-13.402-10.931-24.333-24.333-24.333h-15.208c-13.402,0-24.333,10.931-24.333,24.333v84.694
		c0,13.402,10.931,24.333,24.333,24.333h15.208c13.402,0,24.333-10.931,24.237-24.333l0.036-25.573h76.452v275.748h-76.452
		l-0.036-25.573c0.095-13.402-10.835-24.333-24.237-24.333h-15.208c-13.402,0-24.333,10.931-24.333,24.333v84.694
		c0,13.402,10.931,24.333,24.333,24.333h15.208c13.402,0,24.333-10.931,24.333-24.333l-0.036-24.808h190.7l-0.036,24.808
		c0,13.402,10.931,24.333,24.333,24.333h15.208c13.402,0,24.333-10.931,24.333-24.333v-84.694c0-13.402-10.931-24.333-24.333-24.333
		h-15.208c-13.402,0-24.333,10.931-24.237,24.333l-0.036,25.573h-77.195V118.951H351.532z"
        />
      </g>
    </svg>
  );
};

export default Icon;
